/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { terrain_full } from './terrain_full';
export type map_element_full = {
  id: number;
  origin: map_element_full.origin;
  orientation: map_element_full.orientation;
  origin_x: map_element_full.origin_x;
  from_x: number;
  origin_y: map_element_full.origin_y;
  from_y: number;
  terrain: terrain_full;
};
export namespace map_element_full {
  export enum origin {
    TOP_LEFT = 'TopLeft',
    TOP_RIGHT = 'TopRight',
    BOTTOM_RIGHT = 'BottomRight',
    BOTTOM_LEFT = 'BottomLeft',
  }
  export enum orientation {
    HORIZONTAL = 'Horizontal',
    VERTICAL = 'Vertical',
    DIAGONAL_TOP = 'DiagonalTop',
    DIAGONAL_BOTTOM = 'DiagonalBottom',
  }
  export enum origin_x {
    LEFT = 'Left',
    RIGHT = 'Right',
  }
  export enum origin_y {
    TOP = 'Top',
    BOTTOM = 'Bottom',
  }
}
